import { Button } from '@synoptic/ui-kit/button/button.js';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.js';
import { ArrowLeftIcon } from '@synoptic/ui-kit/icons/react/arrow-left.js';
import { PlusIcon } from '@synoptic/ui-kit/icons/react/plus.js';
import {
  ModalRoot,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { PropsWithChildren, useState } from 'react';
import { AiFilterInput } from '@/__generated__/graphql';
import { ManageFilterModal } from '../manage-filter/manage-filter';
import { AiFilter } from '../types';
import { FilterItem } from './filter-item';
import { backButton, createFilterButton } from '../ai-filters.css';
import { modalFooterWithFlexEnd } from '../manage-filter/manage-filter.css';
import { manageFiltersContainer } from './manage-filters.css';

type ManageFiltersModalProps = {
  aiFilters: AiFilter[];
  createFilter: (filter: AiFilterInput) => Promise<boolean>;
};

export const ManageFiltersModal = ({
  aiFilters,
  children,
  createFilter,
}: PropsWithChildren<ManageFiltersModalProps>) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ModalRoot open={isOpen} onOpenChange={setIsOpen}>
      <ModalTrigger asChild>{children}</ModalTrigger>
      <ModalContent>
        <ModalHeader withoutCloseIcon>
          <IconButton
            onClick={() => setIsOpen(false)}
            className={backButton}
            variant="ghost"
            size="small"
          >
            <ArrowLeftIcon style={{ width: 24, height: 24 }} />
          </IconButton>
          <ModalTitle>Manage your filters</ModalTitle>
        </ModalHeader>
        <div className={manageFiltersContainer}>
          {aiFilters.length === 0 && (
            <>
              <EmptyState
                heading="No filters found"
                description="Create a new filter to get started"
              />
              <ManageFilterModal onSubmit={createFilter}>
                <Button
                  startIcon={<PlusIcon />}
                  variant="secondary"
                  size="small"
                  className={createFilterButton}
                >
                  Create new AI filter
                </Button>
              </ManageFilterModal>
            </>
          )}
          {aiFilters?.map((filter) => (
            <FilterItem key={filter.id} filter={filter} />
          ))}
        </div>
        <div className={modalFooterWithFlexEnd}>
          <Button onClick={() => setIsOpen(false)} variant="primary">
            Done
          </Button>
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
